<template>
  <div class="format-information">
    <div class="d-flex flex-row" style="gap: 12px">
      <span class="price-1">R$ {{ localeString(offer.price_1, 2) }}</span>
      <span class="price-2">R$ {{ localeString(offer.price_2, 2) }}</span>
    </div>
    <custom-chip green-chip bold>
      <span>Desconto absoluto</span>
    </custom-chip>
    <div class="d-flex flex-row align-center" style="gap: 16px">
      <span v-if="!isMobile && offer.minimum_per_client" class="min-max-per-client-text"><strong>Mín. CPF: </strong>{{ offer.minimum_per_client }}</span>
      <span v-if="!isMobile" class="min-max-per-client-text"><strong>Máx. CPF: </strong>{{ offer.maximum_per_client }}</span>
    </div>
  </div>
</template>

<script>
import CustomChip from '@/modules/industria/ofertas-trade/views/components/offer-schedule-list/CustomChip.vue'

export default {
  name: 'AbsoluteDiscountMechanic',
  components: {
    CustomChip,
  },
  props: {
    offer: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.format-information {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 16px;

  @media screen and (max-width: $xs-breakpoint) {
    align-items: center;
    gap: 8px;
  }

  .price-1 {
    font-size: 14px;
    text-decoration: line-through;
    color: $cinza-l20;
  }

  .price-2 {
    font-size: 20px;
    font-weight: bold;
    line-height: 24px;
    color: $cinza-d20;
  }

  .min-max-per-client-text {
    color: $cinza-0;
    font-size: 14px;
    margin-right: 6px;
  }
}
</style>
